import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container my-4 py-3">
      <div className="row justify-content-center">
        <div className="col-12 col-md-10 col-lg-8 shadow-lg p-5 rounded bg-white">
          {/* Heading */}
          <div className="text-center mb-4">
            <h3 className="fw-bold" style={{ color: "#0564bf" }}>
              Privacy Policy
            </h3>
            <p className="mt-2 mb-0" style={{ color: "#0564bf" }}>
              Universal HRA Home Services
            </p>
          </div>

          {/* Introduction */}
          <div className="mb-4">
            <p>
              Universal HRA Home Services Pte. Ltd. We
              respects your privacy and is committed to protecting your personal
              data. This Privacy Policy explains how we collect, use, disclose,
              and safeguard your information when you visit our website{" "}
              <a href="https://universalhra.com" target="_blank" rel="noopener noreferrer">
                https://universalhra.com
              </a>
              , contact us via WhatsApp, or use our cleaning and home services.
            </p>
          </div>

          {/* 1. Information We Collect */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}>1. Information We Collect</h5>
            <p>We may collect the following types of personal data:</p>
            <ul>

              <li>
                <strong>Contact Details:</strong> Name, phone number, email address,
                and home or office address.
              </li>
              <li>
                <strong>Service Information:</strong> Details about the services you
                request or book (e.g., type of cleaning, date, time).
              </li>
              <li>
                <strong>Payment Details:</strong> Payment confirmation or receipts
                (processed securely through third-party systems).
              </li>
              <li>
                <strong>Communication Data:</strong> Messages and calls via WhatsApp,
                SMS, or email.
              </li>
              <li>
                <strong>Technical Data:</strong> IP address, browser type, and usage
                patterns (collected through cookies or analytics tools).
              </li>
            </ul>
          </div>

          {/* 2. How We Use Your Information */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}>2. How We Use Your Information</h5>
            <p>We use your data to:</p>
            <ul>
              <li>Provide, manage, and confirm your bookings.</li>
              <li>Communicate with you via WhatsApp, email, or phone.</li>
              <li>
                Send service reminders, promotions, and important updates (only
                with your consent).
              </li>
              <li>Improve our website and customer experience.</li>
              <li>Comply with legal and regulatory requirements in Singapore.</li>
            </ul>
          </div>

          {/* 3. WhatsApp Communication */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}>3. WhatsApp Communication</h5>
            <p>
              By contacting us on WhatsApp or submitting your number through our
              website, you consent to receive messages from Universal HRA Home
              Services.
            </p>
            <p>We may use automated messages for:</p>
            <ul>
              <li>Booking confirmations</li>
              <li>Payment notifications</li>
              <li>Service reminders</li>
              <li>Promotions and feedback requests</li>
            </ul>
            <p>
              You can opt out anytime by replying “STOP” or contacting us directly
              at{" "}
              <a href="mailto:support@Universalhra.com">
                support@universalhra.com
              </a>
              .
            </p>
          </div>

          {/* 4. Data Protection and Security */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}>4. Data Protection and Security</h5>
            <p>We take your privacy seriously and protect your information using:</p>
            <ul>
              <li>Encrypted communication channels</li>
              <li>Secure servers and restricted data access</li>
              <li>
                Regular data backups and compliance with Singapore’s PDPA
              </li>
            </ul>
            <p>We never sell or rent your personal information to third parties.</p>
          </div>

          {/* 5. Sharing of Information */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}>5. Sharing of Information</h5>
            <p>We may share limited data with:</p>
            <ul>
              <li>
                Service partners (e.g., cleaners, supervisors) for scheduling and
                coordination.
              </li>
              <li>
                Technology providers (e.g., WhatsApp Business API, hosting services)
                for communication and operations purposes.
              </li>
              <li>Government authorities, only when required by law.</li>
            </ul>
            <p>All partners are bound by confidentiality and data protection agreements.</p>
          </div>

          {/* 6. Cookies and Website Tracking */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}>6. Cookies and Website Tracking</h5>
            <p>
              Our website may use cookies or analytics tools to improve user
              experience. You can disable cookies in your browser settings, but
              some site features may not function properly.
            </p>
          </div>

          {/* 7. Your Rights */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}>7. Your Rights</h5>
            <p>Under the Personal Data Protection Act (PDPA), you have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Request correction or deletion</li>
              <li>Withdraw consent for data use</li>
            </ul>
            <p>To exercise these rights, contact us at {" "}
              <a href="mailto:support@Universalhra.com">
                support@universalhra.com
              </a></p>
          </div>

          {/* 8. Retention of Data */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}>8. Retention of Data</h5>
            <p>We keep your personal data only as long as necessary for:</p>
            <ul>
              <li>Providing services you requested</li>
              <li>Fulfilling legal or accounting obligations</li>
              <li>Handling any service-related disputes</li>
            </ul>
            <p>After that, your data will be securely deleted or anonymized.</p>
          </div>

          {/* 9. Third-Party Links */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}>9. Third-Party Links</h5>
            <p>
              Our website or WhatsApp messages may include links to external websites.
              We are not responsible for the privacy practices of those websites.
              Please review their privacy policies separately.

            </p>
          </div>

          {/* 10. Updates to This Policy */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}>10. Updates to This Policy</h5>
            <p>We may update this Privacy Policy from time to time. The updated
              version will be posted on our website with a new “Last Updated” date.

            </p>
          </div>

          {/* 11. Contact Us */}
          <div>
            <h5 style={{ color: "#0564bf" }}>11. Contact Us</h5>
            <p>If you have questions about this Privacy Policy or how we handle your
              personal data, please contact:
            </p>
            <address>
              <strong>Universal HRA Home Services</strong>
              <br />
              Address: 664D Jurong West Street 64, #03-194
              <br />
              Email:{" "}
              <a href="mailto:support@Universalhra.com">
                support@universalhra.com
              </a>
              <br />
              Phone / WhatsApp:{" "}
              <a href="tel:+6588058461" className="text-decoration-none">
                +65 9650 0536
              </a>
              <br />
             
            </address>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
